import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { func } from 'prop-types';
/**
 * This component can be used along with {@link LazyLoadImages}. Children of `EagerLoadImages` are forced to be eager, if they match the given predicate
 *
 * See {@link LazyLoadImages} for example usage
 * @component
 * @category Images
 */

export var EagerLoadImages = /*#__PURE__*/function (_React$Component) {
  _inherits(EagerLoadImages, _React$Component);

  var _super = /*#__PURE__*/_createSuper(EagerLoadImages);

  function EagerLoadImages() {
    _classCallCheck(this, EagerLoadImages);

    return _super.apply(this, arguments);
  }

  _createClass(EagerLoadImages, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        lazyLoadEagerPredicate: this.props.predicate || function () {
          return true;
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return EagerLoadImages;
}(React.Component);
EagerLoadImages.childContextTypes = {
  lazyLoadEagerPredicate: func
};